import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { markdownSizesFor } from "../../components/markdown/markdownSizes";
import { sameNodePosition, } from "../../components/markdown/utils";
import { cn } from "../../lib/utils";
import React, { memo } from "react";
const headingSpacing = {
    1: "pb-2 pt-4",
    2: "pb-2 pt-4",
    3: "pb-2 pt-4",
    4: "pb-1.5 pt-3",
    5: "pb-1 pt-2.5",
    6: "pb-1 pt-2.5",
};
export const H1Block = memo(({ children, id }) => {
    const { textColor, forcedTextSize, textSize } = useMarkdownStyle();
    return (React.createElement("h1", { id: id, className: cn(headingSpacing[1], forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(textSize).headers.h1, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.id === next.id);
H1Block.displayName = "H1Block";
export const H2Block = memo(({ children, id }) => {
    const { textColor, forcedTextSize, textSize } = useMarkdownStyle();
    return (React.createElement("h2", { id: id, className: cn(headingSpacing[2], forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(textSize).headers.h2, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.id === next.id);
H2Block.displayName = "H2Block";
export const H3Block = memo(({ children, id }) => {
    const { textColor, forcedTextSize, textSize } = useMarkdownStyle();
    return (React.createElement("h3", { id: id, className: cn(headingSpacing[3], forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(textSize).headers.h3, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.id === next.id);
H3Block.displayName = "H3Block";
export const H4Block = memo(({ children, id }) => {
    const { textColor, forcedTextSize, textSize } = useMarkdownStyle();
    return (React.createElement("h4", { id: id, className: cn(headingSpacing[4], forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(textSize).headers.h4, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.id === next.id);
H4Block.displayName = "H4Block";
export const H5Block = memo(({ children, id }) => {
    const { textColor, forcedTextSize, textSize } = useMarkdownStyle();
    return (React.createElement("h5", { id: id, className: cn(headingSpacing[5], forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(textSize).headers.h5, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.id === next.id);
H5Block.displayName = "H5Block";
export const H6Block = memo(({ children, id }) => {
    const { textColor, forcedTextSize, textSize } = useMarkdownStyle();
    return (React.createElement("h6", { id: id, className: cn(headingSpacing[6], forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(textSize).headers.h6, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.id === next.id);
H6Block.displayName = "H6Block";
//# sourceMappingURL=HeadingBlock.js.map